import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, SecondaryButton } from "../../../components/UIkit";

import { getBases } from "../../../reducks/base/selectors";
import { fetchbases, saveBases } from "../../../reducks/base/operations";
import SetBasesArea from "../../../components/master/SetBasesArea";
import { push } from "connected-react-router";

const OrderingBaseEdit = () => {
  const dispatch = useDispatch();
  const basesOnFirestore = useSelector(getBases);
  const [bases, setBases] = useState(basesOnFirestore);
  const transition = useCallback(
    (path) => {
      dispatch(push(path));
    },
    [dispatch]
  );
  // コンポーネントが初めてマウントされたときにbasesを取得
  useEffect(() => {
    console.log("useEffect");
    dispatch(fetchbases());
  }, [dispatch]);
  useEffect(() => {
    setBases(basesOnFirestore);
  }, [basesOnFirestore]);

  return (
    <section>
      <h2 className="u-text__headline u-text-center">拠点の登録・編集</h2>
      <div className="c-section-container">
        <SetBasesArea bases={bases} setBases={setBases} />
      </div>
      <div className="module-spacer--small" />
      <div className="center">
        <PrimaryButton
          label={"上書き保存"}
          onClick={() => dispatch(saveBases(bases))}
        />
      </div>
      <div className="center">
        <SecondaryButton
          label={"戻る"}
          onClick={() => transition("/ordering-department/menu")}
        />
      </div>
    </section>
  );
};

export default OrderingBaseEdit;
